<template>
  <b-modal
    id="subsection-download-modal"
    title="Download PDF Report"
    :visible="visible"
    centered
    @hidden="handleHidden"
  >
    <p class="mt-0 mb-3">Select the sections to include in your PDF report:</p>

    <b-form-checkbox
      v-for="section in sections"
      :key="section.key"
      v-model="selectedKeys"
      :value="section.key"
      :disabled="isGenerating"
      class="mb-2"
    >
      {{ section.label }}
    </b-form-checkbox>

    <template #modal-footer="{ cancel }">
      <b-button variant="outline-secondary" @click="cancel">Cancel</b-button>
      <b-button variant="primary" :disabled="!hasSelection || isGenerating" @click="handleDownload">
        <b-spinner v-if="isGenerating" small class="mr-2" />
        {{ isGenerating ? 'Generating...' : 'Download' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script setup>
import { computed, ref } from 'vue';
import useSubsectionDownload from '@/composables/useSubsectionDownload';

const props = defineProps({
  sections: {
    type: Array,
    required: true,
  },
  visible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['hidden']);

const selectedKeys = ref([]);
const { isGenerating, downloadSheets } = useSubsectionDownload();

const hasSelection = computed(() => selectedKeys.value.length > 0);

function resetSelection() {
  selectedKeys.value = [];
}

function handleHidden() {
  resetSelection();
  emit('hidden');
}

async function handleDownload() {
  const selected = props.sections.filter(s => selectedKeys.value.includes(s.key));
  const result = await downloadSheets(selected);
  if (result?.success) {
    resetSelection();
    emit('hidden');
  }
}
</script>
